import { DropzoneComponent, DropzoneConfigInterface, DROPZONE_CONFIG, DropzoneDirective } from 'ngx-dropzone-wrapper';
import { SectorModel } from '../../service/sector.model';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TrainService } from './../../service/train.service';
import { DBConnectorService } from './../../service/test.service';
import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})

export class UpdateComponent implements OnInit, OnDestroy {


  Sub: Subscription;
  @ViewChild(DropzoneDirective) directiveRef: DropzoneDirective;
  result: any = {};


  sectormodel = new SectorModel;
  Admin = false;
  RoleId = '';

  public config: DropzoneConfigInterface = {
    url: "/api/Home/SaveUploadedTaxCodeMappingFile" + "?Sector=" + this.dbconnectorservice.SectorName + "&Model=" + this.dbconnectorservice.ModelName,
    clickable: true,
    uploadMultiple: false,
    autoReset: null,
    errorReset: 15000,
    cancelReset: 15000,
    maxFiles: 1,
    createImageThumbnails: true,
    dictDefaultMessage: "Drag and Drop or Click to browse for files",
    acceptedFiles: ".xlsx",

  };

  constructor(private dbconnectorservice: DBConnectorService,
    private trainservice: TrainService,
    private http: HttpClient,
    private router: Router,
  ) {
    this.sectormodel.SectorName = this.dbconnectorservice.SectorName;
    this.sectormodel.ModelName = this.dbconnectorservice.ModelName;
    this.Admin = this.dbconnectorservice.Admin;
    this.RoleId = this.dbconnectorservice.RoleID;
    this.dbconnectorservice.onGetSec.subscribe((res) => { this.sectormodel.SectorName = res; });
    this.Sub = this.dbconnectorservice.onGetMod.subscribe((res) => {
      this.sectormodel.ModelName = res;
      this.result["UpdateError"] = null;
      this.configset();
    });

    if (this.sectormodel.SectorName == null || this.sectormodel.SectorName == "null") {
      this.result["UpdateError"] = "Sector and Model have not been selected !";
    }
  }

  configset() {
    let url1 = "/api/Home/SaveUploadedTaxCodeMappingFile" + "?Sector=" + this.dbconnectorservice.SectorName + "&Model=" + this.dbconnectorservice.ModelName;
    // var resource = this.adalService.GetResourceForEndpoint(url1);
    // let token = this.adalService.getCachedToken(resource);
    // let tokenbearer = 'Bearer ' + token;

    this.config = {
      url: url1,
      headers: {
        'Authorization': this.dbconnectorservice.getToken(url1)
      },
      clickable: true,
      uploadMultiple: false,
      autoReset: null,
      errorReset: 15000,
      cancelReset: 15000,
      maxFiles: 1,
      createImageThumbnails: true,
      dictDefaultMessage: "Drag and Drop or Click to browse for files",
      acceptedFiles: ".xlsx",
      timeout: 240000
    };
  }

  onUploadError(args: any) {
    //console.log('onUploadError:',  args);
  }
  onUploadSuccess(args: any) {
    // console.log('onUploadSuccess:',  args);
    this.result = args[1];
  }


  //FileUpload
  fileChange(event: any) {
    alert("Uploading Files");
    let fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      console.log(fileList)
      for (var i in fileList) {
        let file: File = fileList[i];
        let formData: FormData = new FormData();
        formData.append('uploadFile', file, file.name);
        //console.log(formData);
        let options = {
          headers: new HttpHeaders({
            'Accept': 'application/json'
          })
        }
        let apiUrl = "/api/Home/SaveUploadedTaxCodeMappingFile" + "?Sector=" + this.dbconnectorservice.SectorName + "&Model=" + this.dbconnectorservice.ModelName;
        this.http.post<any>(apiUrl, formData, options)
          //.catch(error => Observable.throw(error))
          .subscribe(
            (data) => {
              console.log(data);
              this.result = data;
            }
            //error => console.log("error");
          )
      }
      alert("Files Uploaded");
    }
  }

  ngOnInit() {
    this.configset()

  }
  ngOnDestroy() {
    this.Sub.unsubscribe();
  }

}
